import { StaticImageData } from 'next/image';
import imageUrl from '../../../public/webp/fromJPG/rumble-fish-backyard.webp';
import type { HeroProps } from './ImageSection.types';
import {
  StyledSection,
  StyledStack,
  StyledImageContainer,
  StyledImage,
  StyledText,
} from './styles';

export const ImageSection = ({ ...props }: HeroProps) => {
  return (
    <StyledSection width="small">
      <StyledStack {...props}>
        <StyledImageContainer>
          <StyledImage
            src={(imageUrl as unknown as StaticImageData)?.src}
            alt="Our Garden"
          />
        </StyledImageContainer>
        <StyledText variant="regular_500">
          Most of us work from our awesome office in Kraków, where the coffee is
          strong, the atmosphere is laid-back, and yes—dogs are totally welcome.
          Whether you're brainstorming big ideas, taking a break in our PS5
          chillout zone, or getting a much-needed dose of puppy therapy, it’s a
          place where you’ll actually enjoy spending your time. Oh, and did we
          mention the backyard? It’s the perfect spot for our legendary office
          parties and after-hours BBQs. Work hard, grill harder.
        </StyledText>
      </StyledStack>
    </StyledSection>
  );
};
